module.exports = __webpack_public_path__ + "static/media/9DESA25.e6fb8435.jpg";